import { InjectionToken, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';

import {
  AptHeaderComponent,
  CurrentUserResolverService,
  FeatureListResolverService,
  categorizationSchemesResolver,
} from '@aptitude/shared';
import { ExternalHomeComponent } from './external-home/external-home.component';
import { environment } from '../environments/environment';

// This custom injector is used so that we can direct back to the old site
const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
const externalSignOutProvider = new InjectionToken('externalSignOutProvider');

// For local development add any new routes to proxy.conf.js as a bypass
const routes: Routes = [
  {
    path: 'externalHome',
    component: ExternalHomeComponent,
    resolve: {
      goHome: externalUrlProvider,
    },
  },
  {
    path: '',
    component: AptHeaderComponent,
    resolve: {
      currentUser: CurrentUserResolverService,
      features: FeatureListResolverService,
      categorizationSchemes: categorizationSchemesResolver,
    },
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'landing',
        loadChildren: () =>
          import('./home/home-page/home-page.module').then(
            (m) => m.HomePageModule,
          ),
      },
      {
        path: 'catalog',
        loadChildren: () =>
          import('@aptitude/catalog').then((m) => m.CatalogModule),
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('@aptitude/identity').then((m) => m.CompanySettingsModule),
      },
      {
        path: 'measurement',
        loadChildren: () =>
          import('@aptitude/measurement').then((m) => m.MeasurementAppModule),
      },
      {
        path: 'rfp',
        loadChildren: () =>
          import('@aptitude/rfp-routing').then((m) => m.RfpRoutingModule),
      },
      {
        path: 'purchase-planning',

        loadChildren: () =>
          import('@aptitude/rfp-routing').then((m) => m.RfpRoutingModule),
      },
    ],
  },
  {
    path: 'admin',
    loadChildren: () => import('@aptitude/admin').then((m) => m.AdminModule),
  },
  {
    path: 'signIn',
    loadChildren: () => import('@aptitude/sign-in').then((m) => m.SignInModule),
  },
  {
    path: '**',
    redirectTo: '/externalHome',
    pathMatch: 'full',
  },
];

@NgModule({
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        if (
          environment.production ||
          route.queryParamMap.get('bypassProductionGuard') === 'true'
        ) {
          window.location.href = '/aptitude/static/platform/home/landing';
        } else {
          console.warn('Not redirected to home due to dev mode');
        }
      },
    },
    {
      provide: externalSignOutProvider,
      useValue: () => {
        window.location.href = '/aptitude/resources/aptitude_logout';
      },
    },
  ],
  imports: [
    RouterModule.forRoot(routes, {
      // enableTracing: true,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
